import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Group } from '../person/group';
import { GoogleService } from './google-service';

@Service()
export class GroupService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private urlBase = environment.serviceUrl;

  getAllGroups(): Observable<Group[]> {
    const url = this.urlBase + 'group/all';
    return this.http.get<Group[]>(url, { headers: this.getRequestHeaders() });
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
